import Typography from '@cobliteam/ui/components/Typography';
import Icon, { type IconNames } from '@cobliteam/ui/icons';

interface IconLabelledItemProps {
  iconName: IconNames;
  label: string;
  iconColor?: string;
}

const IconLabelledItem = ({ iconName, label, iconColor }: IconLabelledItemProps) => {
  return (
    <div className='flex items-center gap-2'>
      <Icon name={iconName} className={`size-4 ${iconColor || 'text-gray-dark'}`} />
      <Typography variant='body' className='text-gray-dark'>
        {label}
      </Typography>
    </div>
  );
};

export default IconLabelledItem;
